import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";

type props = {
  rowData: any;
  rowCount?: number;
  loading?: boolean;
  columnDef: any;
  onRowSelectionModelChange?: any;
  rowSelectionModel?: any;
  disableVirtualization?: boolean;
  disableColumnMenu?: boolean;
  headerHeight?: number;
  paginationModel?: any;
  onPaginationModelChange?: any;
  checkboxSelection?: boolean;
  rowHeight?: number;
  disableColumnResize?: boolean;
  onRowClick?: (params: any) => void;
  processRowUpdate?: (params: any, event: any) => any;
  isRowSelectable?: any;
  getRowClassName?: any;
  keepNonExistentRowsSelected?: boolean;
};

export default function Table({
  rowData,
  rowCount,
  loading,
  columnDef,
  onRowSelectionModelChange,
  rowSelectionModel,
  disableVirtualization = false,
  disableColumnMenu = false,
  headerHeight,
  paginationModel,
  onPaginationModelChange,
  checkboxSelection = true,
  rowHeight,
  disableColumnResize = true,
  onRowClick,
  processRowUpdate,
  isRowSelectable,
  getRowClassName,
  keepNonExistentRowsSelected,
}: props) {
  return (
    <Paper sx={{ height: 500, width: "100%" }}>
      <DataGrid
        sx={{
          ".MuiDataGrid-columnSeparator": {
            display: disableColumnResize ? "none" : "",
          },
          "& .no-separator .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          '& .MuiDataGrid-columnHeader[data-field="__check__"] .MuiDataGrid-columnSeparator':
            {
              display: "none",
            },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold !important",
          },
          ".MuiDataGrid-columnHeaderTitleContainer": {
            alignItems: "flex-start",
            marginTop: "15px",
          },
          ".MuiDataGrid-columnHeaderTitleContainerContent": {
            pt: 1,
          },
          ".MuiCheckbox-root": {
            padding: "0px 8px",
          },
          ".MuiDataGrid-row": {
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#E35F0014 !important",
            },
          },
        }}
        rows={rowData}
        rowCount={rowCount}
        loading={loading}
        columns={columnDef}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10, 20, 50]}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        checkboxSelection={checkboxSelection}
        disableVirtualization={disableVirtualization}
        disableRowSelectionOnClick
        disableColumnResize={disableColumnResize}
        onRowSelectionModelChange={onRowSelectionModelChange}
        rowSelectionModel={rowSelectionModel}
        disableColumnMenu={disableColumnMenu}
        columnHeaderHeight={headerHeight}
        paginationMode="server"
        rowHeight={rowHeight}
        onRowClick={onRowClick}
        processRowUpdate={processRowUpdate}
        onCellKeyDown={(params, event) => {
          if (event.key === "Enter") return;
          if (event.key.length === 1 && !event.ctrlKey && !event.metaKey) {
            event.stopPropagation(); // prevents edit mode from starting
          }
        }}
        isRowSelectable={isRowSelectable}
        getRowClassName={getRowClassName}
        keepNonExistentRowsSelected={keepNonExistentRowsSelected}
      />
    </Paper>
  );
}
